import {
  ActionDropdownSelections,
  useSafetyDeviceSearchApi,
} from "~/api/GeneratedApi";
import { useCustomQuery } from "~/utils/hooks/useCustomQuery";
import { NullCheck } from "../tabs/SecurityDeviceSearchTab";

export const useActionSearchOptions = (
  dto: NullCheck<ActionDropdownSelections> = {},
) => {
  const { getSdActionDropdownInfos } = useSafetyDeviceSearchApi();

  const {
    data: actionDropDown,
    isFetching,
    isLoading,
  } = useCustomQuery(
    { key: "action-dropdown-search", dto },
    () => getSdActionDropdownInfos({ ...dto } as ActionDropdownSelections),
    { staleTime: 1000 * 5 * 60 },
  );

  return { actionDropDown, isFetching, isLoading };
};
